<template>
  <div class="ecm__change-photo">
    <el-dialog
      title="Change Photo"
      :visible.sync="isShow"
      :show-close="true"
      :before-close="handleCancel"
    >
      <div>
        <cropper
          v-if="imgSrc"
          ref="cropper"
          class="cropper"
          :src="imgSrc"
          :stencil-props="{
            aspectRatio: 1,
          }"
          :stencil-component="$options.components.CircleStencil"
          @change="change"
        />
        <div v-else class="emptyImage">
            <i class="fas fa-image"></i>
        </div>
      </div>
      <div class="ecm__change-photo__actions">
        <button class="ecm__change-photo__actions-btn-file">
          <input type="file" id="image" ref="fileInputRef" @change="loadImage($event)" accept="image/*">
          <label for="image">Choose a photo</label>
        </button>
        <button
          class="ecm__change-photo__actions-btn-save"
          @click="cropImage"
          v-if="imgSrc"
        >
        Save
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { instance as Axios } from '@/config/axiosInstance'
import { Cropper, CircleStencil } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';
import { mapActions, mapMutations, mapState } from 'vuex';

// This function is used to detect the actual image type, 
function getMimeType(file, fallback = null) {
	const byteArray = (new Uint8Array(file)).subarray(0, 4);
  let header = '';
  for (let i = 0; i < byteArray.length; i++) {
      header += byteArray[i].toString(16);
  }
	switch (header) {
        case "89504e47":
            return "image/png";
        case "47494638":
            return "image/gif";
        case "ffd8ffe0":
        case "ffd8ffe1":
        case "ffd8ffe2":
        case "ffd8ffe3":
        case "ffd8ffe8":
            return "image/jpeg";
        default:
            return fallback;
    }
}

export default {
  name: 'Change_Photo',
  components: {
    Cropper,
    CircleStencil
  },
  data () {
    return {
      isShow: false,
      type: null,
      imgData: {
        filename: '',
        type: ''
      },
      data: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
      userImage: state => state.user.userImage
    }),
    imgSrc: {
      get () {
        return this.userImage
      },
      set (payload) {
        this.setUserImage(payload)
      }
    }
  },
  destroyed() {
		if (this.imgSrc) {
			URL.revokeObjectURL(this.imgSrc)
		}
	},
  methods: {
    ...mapActions({
      fetchUser: 'user/fetchUser'
    }),
    ...mapMutations({
      setUserImage: 'user/setUserImage'
    }),
    change({ coordinates, canvas }) {
			// console.log(coordinates, canvas)
		},
    handleCancel () {
      if (this.imgSrc) {
        URL.revokeObjectURL(this.imgSrc)
      }
      this.$refs.fileInputRef.value = ''
      this.setIsShow(false)
    },
    loadImage(event) {
			const { files } = event.target;
			if (files && files[0]) {
        this.$data.imgData.filename = files[0].name
				if (this.imgSrc) {
					URL.revokeObjectURL(this.imgSrc)
				}
				const blob = URL.createObjectURL(files[0]);
				const reader = new FileReader();
				reader.onload = (e) => {
          this.imgSrc = blob
          this.$data.imgData.type = getMimeType(e.target.result, files[0]?.type)
				};
        reader.readAsArrayBuffer(files[0]);
			}
      this.$refs.fileInputRef.value = ''
		},
    cropImage() {
      const { canvas } = this.$refs.cropper.getResult();
			if (canvas) {
				const form = new FormData();
				canvas.toBlob(blob => {
          let splitImgSrc = this.imgSrc.split('/')
          const fileName = this.$data.imgData.filename ? this.$data.imgData.filename : splitImgSrc[splitImgSrc.length - 1]
          console.log(fileName, splitImgSrc)
					form.append('type', 'user');
					form.append('imageType', this.$data.imgType);
					form.append('image', blob, fileName);
					Axios({
            url: 'user-photo/' + this.user.id,
            method: 'PATCH',
            data: form
          })
            .then(res => {
              if (res.data.msg === 'success update image profile') {
                this.$refs.fileInputRef.value = ''
                this.imgSrc = res.data.data.image
                this.$message.success('Your profile picture has been changed successfully')
                this.handleFetchUser()
              }
            })
            .catch(err => {
              console.log(err, 'masuk')
            })
				}, this.$data.imgType);
			}
    },
    async handleFetchUser () {
      try {
        const userId = localStorage.getItem('userId')
        if (userId) {
          await this.fetchUser({ userId })
        } else {
          throw { msg: 'user not found' }
        }
      } catch (error) {
        console.log(error)
      }
    },
    setIsShow (payload) {
      this.$data.isShow = payload
    },
    handleYes () {
      this.$data.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__change-photo {
  position: absolute;
  &::v-deep .el-dialog__wrapper {
    .el-dialog {
      .el-dialog__header {
        font-family: var(--font-family);
        .el-dialog__title {
          font-weight: 600;
          font-size: 20px;
          color: var(--color-blue-background);
        }
      }
      .el-dialog__body {
        .cropper,
        .emptyImage {
          height: 300px;
          background: #DDD;
        }
        .emptyImage {
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            font-size: 100px;
          }
        }
        .ecm__change-photo__actions {
          margin-top: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          .ecm__change-photo__actions-btn-file {
            margin-right: 10px;
            border: none;
            outline: none;
            background: yellow;
            input[type="file"] {
              display: none;
            } 
            label {
              cursor: pointer;
              display: block;
              color: var(--color-blue-background);
              padding: 7px 20px;
              font-size: 18px;
              font-weight: 600;
            }
          }
          .ecm__change-photo__actions-btn-save {
            cursor: pointer;
            background: var(--color-blue-background);
            border: none;
            outline: none;
            padding: 7px 20px;
            font-size: 18px;
            font-weight: 600;
            color: var(--color-yellow);
          }
        }
      }
    }
  }
}
</style>